import { columns } from './columns';
import { filters } from './filters';
import { query } from './query';

const componentCategoryConfig = {
    columns,
    filters,
    queryFilter: query,
};

export default componentCategoryConfig;
